import React from "react";
import {Link} from "react-router-dom";
import LinesEllipsis from 'react-lines-ellipsis'
import {electricOutletToTextBrief, GENRES, sizeToTextBrief, soundSystemToTextBrief} from "../../common/utils";
import {Button} from "react-bootstrap";

const ScheduleItem = ({siSlot, venueId, showActRainDate}) => {

    console.log("showActRainDate: " + showActRainDate);

    return (
        <>
            {siSlot !== null &&
                <>
                    {siSlot.type === "scheduled" &&
                        <>
                            <strong>
                                <Link to={`/acts/${siSlot.act_id}`} reloadDocument="true">{siSlot.act_name}</Link>
                            </strong>
                            <br/>
                            <span className="schedule-act-desc">
                                <LinesEllipsis text={siSlot.act_description} maxLine='10' ellipsis='...' trimRight
                                               basedOn='words'/>
                            </span>
                            <br/>
                            <span className="schedule-act-desc">
                                <strong>Genre</strong>: {GENRES.find(genre => genre.value === siSlot.act_genre)?.name}
                            </span>
                            {showActRainDate &&
                                <>
                                    <br/>
                                    <span className="schedule-act-desc">
                                        <strong>Rain date</strong>:&nbsp;
                                        {siSlot.act_rain_date_available &&
                                            <span>Available</span>
                                        }
                                        {!siSlot.act_rain_date_available &&
                                            <span>Unavailable</span>
                                        }
                                    </span>
                                </>
                            }
                        </>
                    }
                    {siSlot.type === "available" &&
                        <>
                        <span className="schedule-act-desc">
                            <p>Slot available</p>
                            <p>
                                <Button size="sm" variant="outline-dark" href={`/venues/${venueId}/contact`}>
                                    Contact
                                </Button>
                            </p>
                            <div>
                                <span dangerouslySetInnerHTML={{__html: sizeToTextBrief(siSlot.size_pref)}}/>
                            </div>
                            <div>
                                <span dangerouslySetInnerHTML={{__html: soundSystemToTextBrief(siSlot.provide_sound_system)}}/>
                            </div>
                            <div>
                                <span dangerouslySetInnerHTML={{__html: electricOutletToTextBrief(siSlot.provide_electric)}}/>
                            </div>
                        </span>
                        </>
                    }
                </>
            }
        </>
    )
}

export default ScheduleItem;
